import {
  withCompInfo,
  createComponentMapperModel,
  withStateRefsValues,
} from '@wix/editor-elements-integrations';
import type { MediaCSSVars } from '@wix/thunderbolt-components-native';
import type {
  SectionDefinition,
  SectionProps,
} from '@wix/thunderbolt-components';
import { isExperimentOpen } from '@wix/editor-elements-common-utils';
import { TranslationKeys } from '../constants';

export const props = withCompInfo<
  SectionProps,
  SectionDefinition,
  SectionProps
>()(['experiments', 'translate'], ({ experiments, translate }, carmiData) => {
  const useWixMediaCanvas = isExperimentOpen(
    experiments,
    'specs.thunderbolt.useWixMediaCanvas',
  );
  const { fillLayers } = carmiData;
  return {
    ...carmiData,
    fillLayers: {
      ...fillLayers,
      useWixMediaCanvas,
    },
    translations: {
      ariaLabel: translate(
        TranslationKeys.namespace,
        TranslationKeys.ariaLabel,
      ),
    },
  };
});

export const css = withCompInfo<
  MediaCSSVars,
  SectionDefinition,
  MediaCSSVars
>()([], (_, carmiCss) => {
  return {
    ...carmiCss,
    '--inherit-transition': 'var(--transition, none)',
  };
});

const stateRefs = withStateRefsValues(['experiments']);

export default createComponentMapperModel({ props, css, stateRefs });
